import { render, staticRenderFns } from "./TagEditModal.vue?vue&type=template&id=5dba9dcc&scoped=true"
import script from "./TagEditModal.vue?vue&type=script&lang=js"
export * from "./TagEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba9dcc",
  null
  
)

export default component.exports